export interface Advisor {
  name: string
  title: string
  titleEs: string
  subtitle: string
  initials: string
  gradient: string
  borderColor: string
  accentColor: string
  bio: string
  photo?: string
  link?: string
  linkedin?: string
  youtube?: string
  confirmed?: boolean
}

export const advisors: Advisor[] = [
  {
    name: 'Shin Fujiyama',
    title: 'Founder',
    titleEs: 'Rol',
    subtitle: '1,000 Schools Honduras',
    initials: 'SF',
    gradient: 'from-haa-midblue to-haa-blue',
    borderColor: 'border-haa-midblue',
    accentColor: 'text-haa-midblue',
    bio: "Shin Fujiyama is a Japanese-American philanthropist and the co-founder/executive director of Students Helping Honduras, a nonprofit focused on expanding access to education. After first volunteering in Honduras as a college student, he committed his life to building schools and supporting communities across the country through the One Thousand Schools vision. Known for turning endurance challenges into fundraising campaigns, he has completed long-distance runs to raise money for new school construction and reconstruction. Through his on-the-ground work and storytelling, he's become one of the most recognizable advocates for Honduran children's education.",
    photo:
      'https://cdn.magicpatterns.com/uploads/mzbFQ9Y86aQqjBcb8T57QY/SFujiyama.jpg',
    link: 'https://onethousandschools.com/about-us/',
    linkedin: 'https://www.linkedin.com/in/shinfujiyama/',
    confirmed: true,
  },
  {
    name: 'Marvin B. Figueroa',
    title: 'Secretary of Health and Human Resources',
    titleEs: 'Secretario de Salud y Recursos Humanos',
    subtitle: 'Commonwealth of Virginia',
    initials: 'MF',
    gradient: 'from-haa-navy to-haa-blue',
    borderColor: 'border-haa-navy',
    accentColor: 'text-haa-navy',
    bio: 'Born in La Ceiba, Honduras, and raised in the Bronx, New York, Marvin B. Figueroa serves as Virginia’s Secretary of Health and Human Resources, overseeing state agencies responsible for health care, behavioral health, public health, and social services for millions of Virginians. His family traces its roots to Santa Rosa de Aguán, a historic Garífuna community along Honduras’s Caribbean coast. He previously served as a presidential appointee at the U.S. Department of Health and Human Services, as Chief of Staff to a United States Senator, and earlier as a Senior Health and Education Advisor in the Senate. At the state level, he served as Legislative Director in Governor Ralph Northam’s administration. A graduate of Vanderbilt University and Harvard University, he remains deeply connected to Honduras and proud of his Garífuna roots.',
    photo:
      'https://cdn.magicpatterns.com/uploads/qfxJcD6KnRMhYRLo9BM7Gk/unnamed.jpg',
    linkedin: 'https://www.linkedin.com/in/marvin-b-figueroa-2b106414/',
    link: 'https://www.governor.virginia.gov/cabinet/name-1081486-en.html',
    confirmed: true,
  },
  {
    name: 'Dr. Jenny Mains',
    title: 'Special Advisor to the Mayor',
    titleEs: 'Asesora Especial de la Alcaldía',
    subtitle: 'City of New Orleans · International Partnerships & Strategic Economic Development',
    initials: 'JM',
    gradient: 'from-haa-skyblue to-haa-midblue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: 'Dr. Jenny Mains is a Honduran-American physician, entrepreneur, humanitarian, and economic development leader. She serves as Special Advisor to the Mayor of New Orleans for International Partnerships and Strategic Economic Development, building relationships with investors, business leaders, educational institutions, trade organizations, and global partners to advance the city’s long-term growth. Previously, she made history as New Orleans’ first Hispanic Deputy Mayor, leading the city’s economic development agenda. Born in Honduras and raised in New Jersey and New Orleans, Dr. Mains earned her medical degree in Honduras and practiced family medicine throughout Central America, including humanitarian work with Doctors Without Borders. In business leadership at CRC Global Solutions, she helped create more than 100 jobs in Honduras and over 500 in the United States, while founding CRC We Care We Share to support families through food assistance, housing, education, workforce development, and community investment. She also serves on HeartGift’s Louisiana Community Impact Board.',
    photo:
      'https://cdn.magicpatterns.com/uploads/jM9fuaFpidkz4PkashG7nv/JennyMains.jpg',
    linkedin: 'https://www.linkedin.com/in/jenny-mains-md-bb0738142/',
    link: 'https://www.nola.com/news/business/talking-business-dr-jenny-mains-deputy-mayor/article_b92a5c8d-89b5-4201-8691-c53989886ff9.html',
    confirmed: true,
  },
  {
    name: 'Karol Marcela Escalante Herrera',
    title: 'Regional Community Developer',
    titleEs: 'Desarrolladora Comunitaria Regional',
    subtitle:
      'Fairfax County Neighborhood and Community Services · Former Director of Immigrant Community Affairs',
    initials: 'KE',
    gradient: 'from-haa-midblue to-haa-navy',
    borderColor: 'border-haa-midblue',
    accentColor: 'text-haa-midblue',
    bio: 'Karol Marcela Escalante Herrera is a Honduran-American public sector executive and community engagement leader with more than 15 years of experience across strategic partnerships, community development, immigration, public policy, civic engagement, and international diplomacy. Born in Tegucigalpa, Honduras, she serves as a Regional Community Developer with Fairfax County Neighborhood and Community Services, working with residents, nonprofits, businesses, community leaders, and government partners to strengthen neighborhoods and expand access to resources. She previously made history as Fairfax County’s first Director of Immigrant Community Affairs as part of the county’s One Fairfax team, advancing initiatives centered on trust, inclusion, equity, and cross-sector collaboration. Her binational perspective reflects a commitment to building bridges across cultures and elevating immigrant and diaspora voices.',
    photo:
      'https://cdn.magicpatterns.com/uploads/3h6ZXoT9qi2iSYAue8pchP/Karol_Escalante.jpg',
    linkedin: 'https://www.linkedin.com/in/karol-escalante-5a498146/',
    confirmed: true,
  },
  {
    name: 'José Francisco Ávila',
    title: 'Chairman of the Board',
    titleEs: 'Presidente de la Junta',
    subtitle: 'Garifuna Coalition USA, Inc. · Author & Cultural Heritage Advocate',
    initials: 'JA',
    gradient: 'from-haa-navy to-haa-midblue',
    borderColor: 'border-haa-navy',
    accentColor: 'text-haa-navy',
    bio: 'José Francisco Ávila is a Honduran-American author, researcher, and cultural heritage advocate whose work has elevated Garifuna history, identity, and cultural preservation in the United States. Born in the Garifuna village of Cristales, Trujillo, Colón, he migrated to Boston at fifteen. He serves as Chairman of the Board of Garifuna Coalition USA, Inc., founded The Garifuna Experience in NYC, and hosts The Garifuna Experience Podcast. He is the author of Pan-Garifuna Afro-Latino Power of Pride and Garifuna Ancestry: The DNA Quest to Decipher the Garifuna Distant Past. Appointed by Mayor Bill de Blasio to the New York City Nightlife Advisory Board, he has also advised the Bronx Music Heritage Center and the Historic Districts Council, whose 2023 Six to Celebrate program recognized the Garifuna Coalition. He holds a Certificate in Afro-Latin American Studies from Harvard University’s ALARI and a B.S. in Accounting from Bentley University.',
    photo:
      'https://cdn.magicpatterns.com/uploads/et3GH6Kwe3T7GsKSEVcqDg/JAvila.jpg',
    link: 'https://garifunacoalition.org/',
    youtube:
      'https://www.youtube.com/playlist?list=PLuEuzWeRSPWhUFWQEnh9neTO1GDq5Bc_q',
    confirmed: true,
  },
  {
    name: 'Marissa Young',
    title: 'Head Softball Coach',
    titleEs: 'Entrenadora Principal de Softbol',
    subtitle: 'Duke University · ACC Coach of the Year',
    initials: 'MY',
    gradient: 'from-haa-blue to-haa-navy',
    borderColor: 'border-haa-blue',
    accentColor: 'text-haa-blue',
    bio: "Marissa Young is a proud Honduran-American leader and one of the most accomplished figures in collegiate softball today. As the inaugural head coach of Duke University's softball program, she built a national contender from the ground up, guiding the Blue Devils to multiple NCAA Tournament appearances, ACC Championships, and the program's first-ever Women's College World Series berth in 2024 — a historic, program-record 52-win season that earned her ACC Coach of the Year honors. A three-time All-American pitcher at the University of Michigan, she graduated as the program's all-time strikeout leader with 927 career strikeouts and later played professionally in Italy and the United States. A trailblazing role model, her leadership, perseverance, and commitment to excellence continue to inspire athletes and families across the country.",
    photo:
      'https://cdn.magicpatterns.com/uploads/jzswz5hb7qWtVBEevLTwUN/marissa-young.jpg',
    link: 'https://goduke.com/sports/softball/roster/coaches/marissa-young/5312',
    youtube: 'https://www.youtube.com/watch?v=LihKF0NxaKA',
    confirmed: true,
  },
  {
    name: 'Mayra Pineda',
    title: 'President & CEO',
    titleEs: 'Presidenta y CEO',
    subtitle: 'Hispanic Chamber of Commerce of Louisiana',
    initials: 'MP',
    gradient: 'from-haa-blue to-haa-midblue',
    borderColor: 'border-haa-blue',
    accentColor: 'text-haa-blue',
    bio: 'Born in Tegucigalpa, Honduras, Mayra Pineda holds a Bachelor of Arts in Business Administration from the Académie des Langues et de Commerce in Geneva, Switzerland. She is a distinguished business leader who serves as President & CEO of the Hispanic Chamber of Commerce of Louisiana. Throughout her career, she has demonstrated a steadfast commitment to fostering strong and enduring business relationships among Louisiana, the Hispanic community, and Latin America. She previously served as Consul General of Honduras, with jurisdiction over New Orleans, Arkansas, Tennessee, Mississippi, and Alabama.',
    photo:
      'https://cdn.magicpatterns.com/uploads/2dzVjN99euSDTp5cscg6Dg/MPineda.png',
    link: 'https://hispanicchamberla.com/our-team/mayra-pineda/',
    confirmed: true,
  },
  {
    name: 'Bryan Girón',
    title: 'Chef & Owner',
    titleEs: 'Chef y Propietario',
    subtitle: 'Perquín · Food Network Chopped Champion',
    initials: 'BG',
    gradient: 'from-haa-blue to-haa-navy',
    borderColor: 'border-haa-blue',
    accentColor: 'text-haa-blue',
    bio: "Bryan Girón is a Honduran-born chef known for blending the bold flavors of Central America with Mediterranean and global influences. Born in Tegucigalpa, Honduras, and raised in New Jersey, Girón discovered his passion for cooking through his grandmother, whose recipes and market traditions continue to inspire his cuisine today. After studying at Johnson & Wales University, he built an impressive culinary résumé working in acclaimed kitchens including Shukette, Barbuto, Bread + Salt, Beauty & Essex, and The Stanton Social. He is the chef and owner of Perquín in Jersey City, where he showcases modern Honduran cuisine through thoughtfully crafted dishes rooted in heritage, travel, and live-fire cooking. In 2026, Girón gained national recognition after becoming the first Honduran-born chef to win Food Network's Chopped.",
    photo:
      'https://cdn.magicpatterns.com/uploads/1mwQgrFyjXzjzbD83Pj3Hh/ALF_Selects_MaxFlatow-24.jpg',
    link: 'https://perquinjc.com/#about',
    confirmed: true,
  },
  {
    name: 'Martha Hernandez',
    title: 'Majority Owner & President',
    titleEs: 'Propietaria Mayoritaria y Presidenta',
    subtitle: 'Extreme Wood Works · Founder, Amor y Fuerza',
    initials: 'MH',
    gradient: 'from-haa-skyblue to-haa-blue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: 'Martha Hernandez is a dynamic force in both the business and philanthropic worlds. As Majority Owner and President of Extreme Wood Works of South Florida, Inc., she has built a career defined by passion, perseverance, and purpose. Originally from Honduras, she assumed leadership of the family business at just 20 years old while balancing life as a young mother and college student. In 2020, following the devastation of Hurricanes Eta and Iota, she led the shipment of five humanitarian aid containers to Honduras and Nicaragua—an effort that gave rise to Amor y Fuerza, a nonprofit that continues to uplift vulnerable communities in Miami and internationally. Dedicated to service and social impact, Martha leads with innovation, compassion, and an uplifting energy that inspires those around her.',
    photo:
      'https://cdn.magicpatterns.com/uploads/5Xg2AVjhqQShfqNvqfpS3S/Martha_wht_outfit_2026.png',
    link: 'https://extremewoodworks.com/',
    linkedin: 'https://www.linkedin.com/in/martha-hernandez-1260202a/',
    confirmed: true,
  },
  {
    name: 'Diana Brown',
    title: 'School Board Member',
    titleEs: 'Rol',
    subtitle: 'Manassas City Public Schools',
    initials: 'DB',
    gradient: 'from-haa-skyblue to-haa-midblue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: "Diana Brown serves on the Manassas City School Board, where she is a visible advocate for strong public schools, inclusive learning environments, and student-centered decision-making. She was elected in 2025 to a four-year term, and she is also the Vice-Chair of Northern Virginia Community College's College Board. An immigrant from Honduras and an award-winning educator, Brown brings deep experience in special education leadership and has been recognized statewide for her work supporting students and teachers.",
    photo:
      'https://cdn.magicpatterns.com/uploads/sPxY4Xb8DhQbk1RWGgqTiC/Diana_Brown_Profile.png',
    link: 'https://www.nvcc.edu/about/leadership/college-board/members/brown.html',
    linkedin: 'https://www.linkedin.com/in/diana-brown-291107a8/',
    confirmed: true,
  },
  {
    name: 'Jose Quiroz',
    title: 'Sheriff',
    titleEs: 'Rol',
    subtitle: "Arlington County Sheriff's Office",
    initials: 'JQ',
    gradient: 'from-haa-navy to-blue-950',
    borderColor: 'border-haa-navy',
    accentColor: 'text-haa-navy',
    bio: "Jose Quiroz serves as Sheriff of Arlington County, Virginia, leading the Sheriff's Office in its responsibilities for jail operations, courthouse security, and community-facing public safety services. He joined the Arlington County Sheriff's Office on September 10, 2001, and rose through the ranks before taking office as Sheriff in January 2023. He is Arlington's first Latino Sheriff, and his parents are immigrants from Honduras, a background he often cites as central to his commitment to service and community trust.",
    photo:
      'https://cdn.magicpatterns.com/uploads/6fUv9Rs178QH3yuvotmBNL/Jose_Quiroz_Profile.png',
    link: 'https://www.arlingtonva.us/Government/County-Leadership/Executive-Bios/Jose-Quiroz',
    confirmed: true,
  },
]
